import Vue from 'vue';

const app = {
  state: {
    parmArr: [],
	},
    mutations: {
	  parmArrChange (state, payload){
      state.parmArr = payload;
      window.localStorage.setItem('parmArr', JSON.stringify(state.parmArr));
    },
	}
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js